import { RefObject, useEffect, useState } from 'react'

/**
 * How much to shrink a page laid out at `targetWidth` so it fits `hostRef`.
 *
 * Never scales up: a narrow page blown up to fill a wide panel is a lie about
 * what a visitor sees. Re-measures whenever the host resizes, so pinning the
 * sidebar or resizing the window keeps the preview honest.
 */
export function useFitScale(
  hostRef: RefObject<HTMLElement | null>,
  targetWidth: number
): number {
  const [availableWidth, setAvailableWidth] = useState(0)

  useEffect(() => {
    const element = hostRef.current
    if (!element) return undefined
    const observer = new ResizeObserver(entries => {
      setAvailableWidth(entries[0].contentRect.width)
    })
    observer.observe(element)
    return () => observer.disconnect()
  }, [hostRef])

  return availableWidth > 0 ? Math.min(1, availableWidth / targetWidth) : 1
}
